(function () {
  'use strict';

  var NATIVE_HOSTS =
    'cart-drawer-component, shopify-cart, shopify-cart-drawer, storefront-cart-drawer, in-context-cart';

  function closeDialogsInTree(root) {
    if (!root || !root.querySelectorAll) return;
    var dialogs = root.querySelectorAll('dialog');
    for (var i = 0; i < dialogs.length; i++) {
      try {
        if (dialogs[i].open && typeof dialogs[i].close === 'function') {
          dialogs[i].close();
        }
      } catch (e) {}
    }
    if (root.shadowRoot) {
      closeDialogsInTree(root.shadowRoot);
    }
  }

  function closeDialogsInsideNativeHosts() {
    var hosts = document.querySelectorAll(NATIVE_HOSTS);
    for (var h = 0; h < hosts.length; h++) {
      closeDialogsInTree(hosts[h]);
    }
  }

  function hideNativeCartHosts() {
    var nodes = document.querySelectorAll(NATIVE_HOSTS);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      try {
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('visibility', 'hidden', 'important');
        el.style.setProperty('pointer-events', 'none', 'important');
        el.style.setProperty('opacity', '0', 'important');
        el.style.setProperty('height', '0', 'important');
        el.style.setProperty('max-height', '0', 'important');
        el.style.setProperty('overflow', 'hidden', 'important');
      } catch (e) {}
    }
  }

  function hideExtraThemeCartDrawers() {
    var drawers = document.querySelectorAll('cart-drawer');
    if (drawers.length <= 1) return;
    for (var j = 1; j < drawers.length; j++) {
      try {
        drawers[j].style.setProperty('display', 'none', 'important');
      } catch (e) {}
    }
  }

  /** Boost AI Search & Discovery injects its own side cart (`.boost-sd__cart--side`) on top of the theme drawer. */
  function hideBoostSideCart() {
    var boost = document.querySelectorAll('.boost-sd__cart');
    for (var k = 0; k < boost.length; k++) {
      var el = boost[k];
      try {
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('visibility', 'hidden', 'important');
        el.style.setProperty('pointer-events', 'none', 'important');
        el.style.setProperty('opacity', '0', 'important');
        el.style.setProperty('height', '0', 'important');
        el.style.setProperty('max-height', '0', 'important');
        el.style.setProperty('overflow', 'hidden', 'important');
      } catch (e) {}
    }
  }

  var debounceTimer;
  function run() {
    closeDialogsInsideNativeHosts();
    hideNativeCartHosts();
    hideBoostSideCart();
    hideExtraThemeCartDrawers();
  }

  function schedule() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(run, 40);
  }

  function boot() {
    run();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
    }
    if (typeof MutationObserver === 'undefined') return;
    var mo = new MutationObserver(schedule);
    if (document.body) {
      mo.observe(document.body, { childList: true, subtree: true });
    }
  }

  document.addEventListener('shopify:section:load', schedule);

  window.__suppressDuplicateCartUi = run;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
